// Mod_Opening.ts — the Opening modifier (Buildings Set1 follow-up).
//
// An Opening is like a Door/Window, but with FEWER properties: it "punches out" the ENTIRE wall
// across its width (from the floor slab top up to the wall top — no sill, no frame, no reveal,
// no model mesh). It's used e.g. to stop wall-mesh-generation between two Rooms that are actually
// part of the same open space (the Rooms act as an organizational unit, but should not generate a
// wall between two neighboring Rooms).
//
// Unlike `Mod_Door`/`Mod_Window` it carries only `width` (and an optional `materials`), so there
// is nothing to author beyond the opening's width.
import {BuildingMaterials} from "./Building/BuildingShared.js";

export class Mod_Opening {
	constructor(data?: Partial<Mod_Opening>) { Object.assign(this, data); }
	width?: number|n;
	materials?: n|BuildingMaterials;
}
